import React, { memo } from 'react';

const DownloadIcon = (props) => (
    <svg
        width="21"
        height="17"
        viewBox="0 0 21 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17.229 6.216C16.956 2.74275 14.0422 0 10.5 0C7.47 0 4.869 1.968 4.02975 4.83825C1.63575 5.66925 0 7.93725 0 10.5C0 13.8082 2.69175 16.5 6 16.5H15.75C18.645 16.5 21 14.145 21 11.25C21 8.88825 19.4475 6.861 17.229 6.216ZM14.0303 10.2803L11.0303 13.2803C10.884 13.4265 10.692 13.5 10.5 13.5C10.308 13.5 10.116 13.4265 9.96975 13.2803L6.96975 10.2803C6.75525 10.0658 6.69075 9.74325 6.807 9.46275C6.92325 9.183 7.197 9 7.5 9H9V6C9 5.172 9.672 4.5 10.5 4.5C11.328 4.5 12 5.172 12 6V9H13.5C13.803 9 14.0767 9.183 14.193 9.46275C14.3092 9.74325 14.2448 10.0658 14.0303 10.2803Z"
            fill="currentColor" />
    </svg>

);

export default memo(DownloadIcon);
